<template>
  <div>
    <div v-if="paginatedProblems.length > 0" class="table-container">
      <table class="table table-sm">
        <thead class="table-light">
          <tr>
            <th scope="col" class="col-ticket-id">Número</th>
            <th scope="col" class="col-title">Ticket</th>
            <th scope="col" class="col-horario">Horário</th>
            <th scope="col" class="col-information">Informações</th>
            <th scope="col" class="col-action">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="problem in paginatedProblems" :key="problem.eventid">
            <th style="vertical-align: middle;" class="fw-normal">{{ problem.ticketId }}</th>
            <td style="vertical-align: middle;">{{ problem.ticketTitle }}</td>
            <td style="vertical-align: middle;">{{ problem.readableTime }}</td>
            <td style="vertical-align: middle;">
              <div class="d-flex gap-1 flex-wrap">
                <div>
                  <a v-if="companyId" :href="`https://sys.metronetwork.com.br/ticket/detail/${problem.ticketId}`"
                    target="_blank" type="button" class="btn btn-light btn-sm m-10">
                    Ticket
                  </a>
                </div>
                <router-link v-if="problem.popId" :to="`/empresas/site/${problem.popId}`" target="_blank">
                  <a type="button" class="btn btn-warning btn-sm">
                    Pop
                  </a>
                </router-link>
                <router-link v-if="problem.pointuc_problem" :to="`/empresas/site/${problem.popId}`" target="_blank">
                  <a type="button" class="btn btn-info btn-sm">
                    UC
                  </a>
                </router-link>
      
                <router-link v-if="problem.pointa_problem || problem.pointb_problem"
                  :to="`/empresas/trecho/${problem.sectionId}`" target="_blank">
                  <a type="button" class="btn btn-danger btn-sm">
                    Trecho &#8594; {{ problem.pointa_problem ? "Ponto A" : "Ponto B" }}
                  </a>
                </router-link>
                <div>
                  <a v-if="problem.instructionId" type="button" class="btn btn-primary btn-sm"
                    :href="problem.instructionLink" target="_blank">
                    Instrução
                  </a>
                </div>
              </div>
            </td>
            <td style="vertical-align: middle;">
              <div class="d-flex gap-1">
                <button type="button" class="btn btn-sm" @click="$router.push(`/problemas/${problem.problemId}`)">
                  <Icon class="icon text-primary" icon="mdi-comment" />
                </button>
                <button v-if="this.showBindOptions(problem)" type="button" class="btn btn-sm"
                  @click="openModalBind(problem)">
                  <Icon class="icon text-primary" icon="material-symbols:join-outline" />
                </button>
                
                <button v-if="isMetroUser(user) && problem.sectionPlaybookId && !problem.playbookExecutionDate" class="btn btn-danger"
                  @click="goAhead(problem)">
                  Go Ahead!
                </button>
                <ModalContent :is-modal-open="problem.hasSharedPlaybook"
                  @close="() => problem.hasSharedPlaybook = false" @send="() => {
                    executeSharedPlaybook(problem);
                    problem.hasSharedPlaybook = false
                  }" :title="`Executar Playbook compartilhado ?`">Última execução: {{problem.sharedPlaybookExecutionDate}}. 
                </ModalContent>
                <button v-if="problem.playbookExecutionDate" class="btn btn-success disabled">
                  Executado
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <ul class="pagination" v-if="totalPages > 1">
        <li class="page-link" @click="prevPage" :class="{ disabled: currentPage === 1 }">
          Anterior
        </li>
        <li class="page-link">{{ currentPage }} de {{ totalPages }}</li>
        <li class="page-link" @click="nextPage" :class="{ disabled: currentPage === totalPages }">
          Próxima
        </li>
      </ul>
    </div>
  </div>

  <ModalContent :is-modal-open="isModalBindOpen" @close="closeModalBind" @send="bindProblem()" title="Víncule o problema"
    :isLoading="isBindingProblem">
    <fieldset>
      <label>Selecione uma Opção</label>
      <div class="d-flex gap-1">
        <button v-for="option in options" :key="option.key"
          :class="['btn', activeOption === option.key ? 'btn-primary' : 'btn-secondary']"
          @click="toggleOption(option.key)">
          {{ option.label }}
        </button>
      </div>

      <div v-if="activeOption === 'instruction'">
        <label>Instrução</label>
        <SearchableSelect :items="instructionsList" placeholder="Selecione uma instrução"
          v-model="selectedProblem.bindInstruction.instruction" />
      </div>

      <div v-if="activeOption === 'section'">
        <label>Trecho</label>
        
        <SearchableSelect :items="sectionsList" placeholder="Selecione um trecho"
          v-model="selectedProblem.bindSection.section" @update:selectedItem="setAvailablePoints" />
        <SearchableSelect v-if="!selectedProblem?.pop?.id" :items="popsSectionsList" placeholder="Selecione um pop"
          v-model="selectedProblem.bindSection.pop" />
        <input v-if="selectedProblem?.pop?.id" :value="selectedProblem.pop.name + '- associada ao host'"
          class="form-control" :style="{ width: '250px' }" type="text" disabled>
        <SearchableSelect v-if="selectedProblem.bindSection.section" :items="sectionsPointList"
          placeholder="Selecione uma ponto" v-model="selectedProblem.bindSection.pointOption" />
      </div>

      <div v-if="activeOption === 'uc'">
        <label>UC</label>
        <SearchableSelect v-if="!selectedProblem?.pop?.id" :items="popsUcsList" placeholder="Selecione um POP"
          v-model="selectedProblem.bindUc.pop" />
        <input v-if="selectedProblem?.pop?.id" :value="selectedProblem.pop.name + '- possui o host'"
          class="form-control" :style="{ width: '250px' }" type="text" disabled>
        <br>
      </div>
    </fieldset>
  </ModalContent>
</template>

<script>
import {formateDate, convertTime } from '../../../../zabbix-shared/utils/time';
import ModalContent from '@/components/ModalContent.vue';
import SearchableSelect from '@/components/SearchableSelect.vue';
import { Icon } from "@iconify/vue";
import { executePlaybook, getProblemsWithRelations, HostService, instructionService, messageTicket, PointService, PopService, problemService, sectionService, TicketCompanyService, ticketMessageService, userService } from '@/services/backend/ApiService';
import dayjs from 'dayjs';
import { ZabbixApiService } from '@/services/backend/zabbixApiService';
import UserService from '@/services/OnlineUserService';
import { isMetroUser } from '../../../../zabbix-shared/utils/user';
import { COMPANY_ID_MAP } from '../../../../zabbix-shared/enums/companyId';
import DinamicaRBXForm from '@/pages/resolution/FormComponents/DinamicaRBXForm.vue';

export default {
  components: {
    ModalContent,
    SearchableSelect,
    DinamicaRBXForm,
    Icon
  },
  props: {
    zabbixId: {
      type: Object,
      required: true,
    },
    companyId: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true
    },
    updateTime: {
      type: Number,
      required: true
    },
    problemsPerPage: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      user: UserService.getUser(),
      problems: [],
      intervalId: null,
      currentPage: 1,
      isModalBindOpen: false,
      isModalCommentOpen: false,
      selectedProblem: null, 
      instructionsList: null,
      activeOption: null,
      isBindingProblem: false,
      functionsList: [],
      options: [
        { key: 'instruction', label: 'Instrução' },
        { key: 'section', label: 'Trecho' },
        { key: 'uc', label: 'UC' },
      ]
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.problems.length / this.problemsPerPage);
    },
    paginatedProblems() {
      const start = (this.currentPage - 1) * this.problemsPerPage;
      const end = start + this.problemsPerPage;
      return this.problems.slice(start, end);
    }
  },
  async mounted() {
    await this.fetchProblems();

    this.startFetchingProblems();
  },
  beforeUnmount() {
    this.stopFetchingProblems();
  },
  methods: {
    isMetroUser,
    async fetchProblems() {
      try {
        let response = await getProblemsWithRelations({
          zabbix_id: this.zabbixId
        });

        if (!response) return;

        this.problems = response.map((problem) => ({
          ...problem,
          readableTime: convertTime(problem.clock),
        }));
      } catch (error) {
        console.error('Erro na requisição:', error);
      } finally {
      }
    },
    startFetchingProblems() {
      this.intervalId = setInterval(() => {
        if (!this.isWithinPolicy) return;

        this.fetchProblems();
      }, this.updateTime);
    },
    stopFetchingProblems() {
      clearInterval(this.intervalId);
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    async openModalBind(problem) {
      this.isModalBindOpen = true;
      this.selectedProblem = problem
      this.selectedProblem.bindInstruction = {};
      this.selectedProblem.bindSection = {};
      this.selectedProblem.bindUc = {}

      this.instructionsList = (await instructionService.findAll({ company: {id: this.companyId }})).map(instruction => {
        return {
          value: instruction,
          option: instruction.name
        }
      });

      const popList = (await PopService.findAll({ company: { id: this.companyId} }))

      this.popsSectionsList = popList.map(pop => {
        return {
          value: pop,
          option: pop.name,
        }
      });
      
      this.selectedProblem.pop = popList.filter(value => value.id == this.selectedProblem.popId)[0];
      this.popsUcsList = popList.map(pop => {
        const disabled = pop.pointUc != null
        return {
          value: pop,
          option: pop.name + (disabled ? "→ Associado" : ""),
          disabled: disabled
        }
      })

      this.sectionsList = (await sectionService.findAll({ company: {id: this.companyId }})).map(section => {
        const disabled = section.pointA?.triggerId != null && section.pointB?.triggerId != null;

        return {
          value: section,
          option: section.name + (disabled ? "→ Associado" : ""),
          disabled: disabled
        }
      });

    },
    setAvailablePoints(section) {
      const triggerA = section?.pointA?.triggerId;
      const triggerB = section?.pointB?.triggerId;

      this.sectionsPointList = [
        {
          value: "pointA",
          option: "Ponto A" + (triggerA ? "→ Associado" : ""),
          disabled: triggerA
        },
        {
          value: "pointB",
          option: "Ponto B" + (triggerB ? "→ Associado" : ""),
          disabled: triggerB
        },
      ]
    },
    closeModalBind() {
      this.isModalBindOpen = false;
    },
    showBindOptions(problem) {
      if (!problem) return false;

      const { pointa_problem, pointb_problem, instructionId, pointuc_problem } = problem;

      return !(pointa_problem || pointb_problem || instructionId || pointuc_problem)
    },
    async bindProblem() {
      this.isBindingProblem = true;

      const point = {
        hostId: this.selectedProblem.hostId,
        itemId: this.selectedProblem.itemId,
        triggerId: this.selectedProblem.triggerId,
        instructionId: this.selectedProblem.instructionId, 
        company: {
          id: this.companyId
        }
      }

      const createdPoint = await PointService.create(point);

      if (this.selectedProblem.bindInstruction?.instruction) {
        createdPoint.instruction = this.selectedProblem.bindInstruction?.instruction;
        await PointService.update(createdPoint.id, createdPoint)
      }

      if (this.selectedProblem.bindSection) {
        let { pop, section, pointOption } = this.selectedProblem.bindSection
        if (this.selectedProblem.pop) pop = this.selectedProblem.pop;

        if (pop && section && pointOption) {
          if (pointOption) {
            section[pointOption] = Object.assign(createdPoint, { popId: pop.id });
          }

          sectionService.update(section.id, section)
          const hostName = (await ZabbixApiService.getHostById(pop.company.id, point.hostId))?.host;

          await HostService.create({
            hostId: point.hostId,
            name: hostName,
            pop: {
              id: pop.id
            },
            company: {
              id: this.companyId
            }
          })
        }
      }

      if (this.activeOption == "uc") {
        let pop = this.selectedProblem.bindUc.pop;
        if (this.selectedProblem.pop) pop = this.selectedProblem.pop;

        if (pop && pop.pointUc == null) {
          pop.pointUc = createdPoint;

          await PopService.update(pop.id, pop)
          const hostName = (await ZabbixApiService.getHostById(pop.company.id, point.hostId))?.host;

          await HostService.create({
            hostId: point.hostId,
            name: hostName,
            popId: pop.id,
            company: {
              id: this.companyId
            }
          })
        }

      }

      this.closeModalBind();
      this.isBindingProblem = false;
      this.fetchProblems();
    },
    toggleOption(key) {
      this.activeOption = this.activeOption === key ? null : key;
      this.selectedProblem.bindInstruction = {};
      this.selectedProblem.bindSection = {};
      this.selectedProblem.bindUc = {}
    },
    async goAhead(problem) {
      await executePlaybook(problem.sectionPlaybookId, {
        problemId: problem.problemId
      });

      let problemData = await problemService.findOne(problem.problemId);
      problemData.playbookExecutionDate = new Date();
      problem.sharedPlaybookExecutionDate = formateDate(problemData.sharedPlaybookExecutionDate);
      
      await problemService.update(problemData.id, problemData)

      if (problem.sectionJumpPlaybookId) {
        problem.hasSharedPlaybook = true;
        problem.existingSharedPlaybook = problem.sectionJumpPlaybookId;
      }
    },
    async executeSharedPlaybook(problem) {
      await executePlaybook(problem.existingSharedPlaybook);

      let problemData = await problemService.findOne(problem.problemId);
      problemData.sharedPlaybookExecutionDate = new Date();

      await problemService.update(problemData.id, problemData)
    },
    async addComment(){
      const ticketMessage = {
        company: {
          id: this.companyId
        },
        problem: {
          id: this.selectedProblem.problemId
        },
        message: this.ticketComment.response
      }
      
      const message = await ticketMessageService.create(ticketMessage);

      const passedTime = new Date().getTime()  + 
      (this.ticketComment.fallowup.hours * 60 * 60 * 1000) + 
      (this.ticketComment.fallowup.minutes * 60 * 1000);

      const futureDate = new Date(passedTime);
      const problemEntity = {
        fallowupTime: futureDate
      }
      
      await problemService.update(this.selectedProblem.problemId, problemEntity)

      await messageTicket(this.ticketComment);
      this.ticketComment.comments.unshift(message);
    },
    formatDate(dateStr) {
      return dayjs(dateStr).format('DD/MM/YYYY HH:mm')
    }
  },
};
</script>

<style scoped>
.col-action {
  width: 220px !important;
}

.table-container {
  max-width: 1200px;
}

.table-sm {
  table-layout: fixed;
  font-size: 14px;
}

.table th,
.table td {
  text-align: left;
  padding: 10px;
}

.col-id {
  width: 100px;
}

.col-horario {
  width: 150px;
}

.col-information {
  width: 300px;
}

.col-ticket-id{
  width: 80px;
}
.col-title {
  width: 200px;
}

.col-acknowledge {
  width: 300px;
}

.col-action {
  width: 100px;
}

fieldset label {
  margin: 10px 0;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.pagination .page-link {
  margin: 0 5px;
  cursor: pointer;
}

.page-link.disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>